import { forwardRef, type Ref, type SVGProps } from "react";

function SvgHoursLimit(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#hours_limit_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#hours_limit_svg__b)" strokeWidth={20} />
      </g>
      <path stroke="#0C1C43" strokeLinecap="round" strokeLinejoin="round" d="M88 32v28l15-16" />
      <rect width={39} height={39} x={29.5} y={10.5} fill="#BD6801" rx={19.5} />
      <rect width={39} height={39} x={29.5} y={10.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M49 24v7m0 3v1"
      />
      <defs>
        <linearGradient
          id="hours_limit_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="hours_limit_svg__a">
          <rect width={100} height={100} x={37.5} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHoursLimit);
export default ForwardRef;
